import { gqlEthnicAppearanceEnum as ETHNIC_APPEARANCE } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';

export const useEthicAppearanceOptions = () => {
  const { t } = useTranslation();

  return [
    {
      value: ETHNIC_APPEARANCE.ABORIGINAL_TORRES_STRAIT_ISLANDER,
      label: t('common:label.ethnicAppearance.aboriginalTorresStraitIslander'),
    },
    { value: ETHNIC_APPEARANCE.AFRICAN_AMERICAN_BLACK, label: t('common:label.ethnicAppearance.africanAmericanBlack') },
    { value: ETHNIC_APPEARANCE.EAST_ASIAN, label: t('common:label.ethnicAppearance.eastAsian') },
    {
      value: ETHNIC_APPEARANCE.EAST_INDIAN_SOUTH_ASIAN,
      label: t('common:label.ethnicAppearance.eastIndianSouthAsian'),
    },
    { value: ETHNIC_APPEARANCE.EASTERN_EUROPEAN, label: t('common:label.ethnicAppearance.easternEuropean') },
    { value: ETHNIC_APPEARANCE.LATINX, label: t('common:label.ethnicAppearance.latinx') },
    { value: ETHNIC_APPEARANCE.MAORI, label: t('common:label.ethnicAppearance.maori') },
    { value: ETHNIC_APPEARANCE.MEDITERRANEAN, label: t('common:label.ethnicAppearance.mediterranean') },
    { value: ETHNIC_APPEARANCE.MIDDLE_EASTERN, label: t('common:label.ethnicAppearance.middleEastern') },
    { value: ETHNIC_APPEARANCE.AMERICAN_INDIAN, label: t('common:label.ethnicAppearance.nativeAmerican') },
    { value: ETHNIC_APPEARANCE.PACIFIC_ISLANDER, label: t('common:label.ethnicAppearance.pacificIslander') },
    { value: ETHNIC_APPEARANCE.SOUTHEAST_ASIAN, label: t('common:label.ethnicAppearance.southeastAsian') },
    { value: ETHNIC_APPEARANCE.CAUCASIAN_WHITE, label: t('common:label.ethnicAppearance.caucasianWhite') },
    { value: ETHNIC_APPEARANCE.ETHNICALLY_AMBIGUOUS, label: t('common:label.ethnicAppearance.ethnicallyAmbiguous') },
  ];
};
